import React from "react";
import {useTranslation} from "react-i18next";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Tooltip from "connectui/component/display/Tooltip";
import Text from "connectui/component/display/Text";
import Container from "connectui/component/layout/Container";

const useStyles = (theme, baseColor) =>
  buildStyles({
    dot: {
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      backgroundColor: theme.colors[baseColor],
    },
    dotBg: {
      cursor: "pointer",
      borderRadius: "50%",
      padding: theme.spacing(1.5),
      marginRight: theme.spacing(1),
      backgroundColor: theme.colors[baseColor.replace("500", "50")],
      "&:hover": {
        backgroundColor: theme.colors[baseColor.replace("500", "100")],
      },
    },
  });

const PaymentStatus = ({status, baseColor}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme, baseColor);
  const {t} = useTranslation();

  return (
    <Tooltip
      interactive
      tooltipContent={
        <FlexContainer flexDirection="column" gap={theme.spacing(1)}>
          <Text variant="textXS" weight="semibold" color="white">
            {t(`inbox.reservation-details.payment.status.${status}`)}
          </Text>
          <Text variant="textXS" color="white" sx={{whiteSpace: "wrap"}}>
            {t(
              `inbox.reservation-details.payment.status-description.${status}`,
            )}
          </Text>
        </FlexContainer>
      }
      leaveDelay={150}
      colors={{bg: "gray900", text: "white"}}
      sx={{
        tooltip: {
          padding: theme.spacing(2),
          maxWidth: 200,
          maxHeight: 200,
        },
      }}
    >
      <Container className={classes.dotBg}>
        <Container className={classes.dot} sx={{}} />
      </Container>
    </Tooltip>
  );
};

export default PaymentStatus;
